import axios from 'axios';
import qs from 'qs';
import store from '../store';

import { resetToken } from '@/utils/token'
axios.defaults.timeout = 30000000;
// axios.defaults.baseURL = 'http://10.193.157.96:10071/';
// axios.defaults.baseURL = 'http://localhost:10071/';
axios.defaults.baseURL = 'http://lggd.ccnu.edu.cn/';
String.prototype.endWith = function(suffix) {
    return this.indexOf(suffix, this.length - suffix.length) !== -1;
};
axios.interceptors.request.use(
	config => {
		if (store.state.token) {
			config.headers.token = store.state.token;
			config.headers.userid = JSON.parse(sessionStorage.getItem('loginData')).userId;
			config.headers.moduleid = 1;
		}
		return config;
	},
	error => {
		return Promise.reject(err);
	}
);


//http response 拦截器
axios.interceptors.response.use(
	response => {

		if (response.data.code === 401) {
			resetToken()
			return Promise.reject(response.data.msg || '服务器错误');
		}
		return response;
	},
	error => {
		if (error.message.indexOf('timeout') > -1) {
			Message.warning('请求超时');
		}
		return Promise.reject(error);
	}
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(data), config)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

export function upload(url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, config)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}